import React from "react";
import { useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MarkdownDocPage } from "@core/components/docs/MarkdownDocPage";
import { SEOHead } from "../components/SEOHead";

export default function Legal() {
  const { t } = useTranslation(["polls", "common", "errors"]);
  const location = useLocation();
  const { docPath } = useParams<{ docPath: string }>();
  const path = location.pathname;

  // Calcul SEO centralisé selon la route
  const seo = path.includes("terms")
    ? {
        title: t("polls:legal_terms_seo_title"),
        description: t("polls:legal_terms_seo_description"),
      }
    : path.includes("privacy-ia") || path.includes("ia-policy")
      ? {
          title: t("polls:legal_ia_seo_title"),
          description: t("polls:legal_ia_seo_description"),
        }
      : path.includes("privacy")
        ? {
            title: t("polls:legal_privacy_seo_title"),
            description: t("polls:legal_privacy_seo_description"),
          }
        : path.includes("legal")
          ? {
              title: t("polls:legal_mentions_seo_title"),
              description: t("polls:legal_mentions_seo_description"),
            }
          : {
              title: t("polls:legal_default_seo_title"),
              description: t("polls:legal_default_seo_description"),
            };

  // Si on accède via /docs/:docPath
  if (docPath) {
    const fileName = docPath.endsWith(".md") ? docPath : `${docPath}.md`;
    return (
      <>
        <SEOHead
          title={t("polls:legal_docs_seo_title")}
          description={t("polls:legal_docs_seo_description")}
        />
        <MarkdownDocPage
          title={t("polls:legal_docs_title")}
          docPath={fileName}
          productType="date"
          subtitle={t("polls:legal_docs_subtitle")}
          icon="docs"
        />
      </>
    );
  }

  if (path.includes("terms")) {
    console.log("🔍 Terms page accessed, path:", path);
    console.log("🔍 Loading cg-u.md from docs/");
    return (
      <>
        <SEOHead title={seo.title} description={seo.description} />
        <MarkdownDocPage
          title={t("polls:legal_terms_title")}
          docPath="cg-u.md"
          productType="date"
          subtitle={t("polls:legal_terms_subtitle")}
          icon="legal"
        />
      </>
    );
  }

  if (path.includes("privacy-ia") || path.includes("ia-policy")) {
    return (
      <>
        <SEOHead title={seo.title} description={seo.description} />
        <MarkdownDocPage
          title={t("polls:legal_ia_title")}
          docPath="ia-policy.md"
          productType="date"
          subtitle={t("polls:legal_ia_subtitle")}
          icon="brain"
        />
      </>
    );
  }

  if (path.includes("privacy")) {
    return (
      <>
        <SEOHead title={seo.title} description={seo.description} />
        <MarkdownDocPage
          title={t("polls:legal_privacy_title")}
          docPath="privacy.md"
          productType="date"
          subtitle={t("polls:legal_privacy_subtitle")}
          icon="legal"
        />
      </>
    );
  }

  if (path.includes("legal")) {
    return (
      <>
        <SEOHead title={seo.title} description={seo.description} />
        <MarkdownDocPage
          title={t("polls:legal_mentions_title")}
          docPath="mentions-legales.md"
          productType="date"
          subtitle={t("polls:legal_mentions_subtitle")}
          icon="legal"
        />
      </>
    );
  }

  // Default fallback
  return (
    <>
      <SEOHead title={seo.title} description={seo.description} />
      <MarkdownDocPage
        title={t("polls:legal_default_title")}
        docPath="cg-u.md"
        productType="date"
        subtitle={t("polls:legal_default_subtitle")}
        icon="docs"
      />
    </>
  );
}
